import { Set } from 'immutable'
import { TopFilters } from '../filtersUtils'
import { Updater } from 'widgets-for-react'

export type TopFiltersState = {
  techniques: TopFilterState
  appearances: TopFilterState
  textures: TopFilterState  
  allergens: TopFilterState
  types: TopFilterState
  modalState: ModalState
}

export type TopFilterState = {
  selected: Set<string>
  toggled: boolean
}

export type ModalState = 'closed' | 'pick filter' | 'allergens' | 'techniques' | 'appearances' | 'textures' | 'types'

const initialTopFilterState = (selected: string[]) => ({
  selected: Set(selected),
  toggled: false,
})

export const initialTopFiltersState = (
  topFilters: TopFilters
): TopFiltersState => ({
  techniques: initialTopFilterState(topFilters?.techniques ?? []),
  appearances: initialTopFilterState(topFilters?.appearances ?? []),
  textures: initialTopFilterState(topFilters?.textures ?? []),  
  allergens: initialTopFilterState(topFilters?.allergens ?? []),
  types: initialTopFilterState(topFilters?.types ?? []),
  modalState: 'closed',
})

export const topFiltersStateUpdaters = {
  techniquesUpdater:
    (updater: Updater<TopFilterState>) =>
    (state: TopFiltersState): TopFiltersState => ({
      ...state,
      techniques: updater(state.techniques),
    }),
  appearancesUpdater:
  (updater: Updater<TopFilterState>) =>
  (state: TopFiltersState): TopFiltersState => ({
    ...state,
    appearances: updater(state.appearances),
  }),
  texturesUpdater:
  (updater: Updater<TopFilterState>) =>
  (state: TopFiltersState): TopFiltersState => ({
    ...state,
    textures: updater(state.textures),
  }),        
  allergensUpdater:
    (updater: Updater<TopFilterState>) =>
    (state: TopFiltersState): TopFiltersState => ({
      ...state,
      allergens: updater(state.allergens),
    }),
  typesUpdater:
    (updater: Updater<TopFilterState>) =>
    (state: TopFiltersState): TopFiltersState => ({
      ...state,
      types: updater(state.types),
    }),    
  singleSelectedUpdater:
    (title: string) =>
    (state: TopFilterState): TopFilterState => {
      const selected = state.selected
      return {
        ...state,
        selected: selected.includes(title)
          ? selected.remove(title)
          : selected.add(title),
      }
    },
  emptySelectedUpdater: (state: TopFilterState): TopFilterState => ({
    ...state,
    selected: Set<string>([]),
  }),
  toggledUpdater: (state: TopFilterState): TopFilterState => ({
    ...state,
    toggled: !state.toggled,
  }),
  modalStateUpdater:
    (modalState: ModalState) =>
    (state: TopFiltersState): TopFiltersState => ({
      ...state,
      modalState: modalState,
    }),
}
